module.exports = __webpack_public_path__ + "img/hr-green-bush-mini-05.124d1302.png";